import type { PresetHOC } from '../types/PresetHOC';

/**
 * Marks the item to render its title and description.
 */
export const withTitle: PresetHOC<{
    showTitleAndDescription?: boolean;
}> = (Item) => {
    Item.showTitleAndDescription = true;

    return Item;
};
